<template>
  <v-dialog
    v-model="show"
    scrollable
    max-width="500"
  >
    <v-card>
      <elac-card-title
        :label="title"
        @close="show = false"
      />
      <v-card-text>{{ message }}</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ElacCardTitle from '@/components/ElacCardTitle.vue';

export default {
  name: 'ElacMessagePopup',
  components: { ElacCardTitle },
  computed: {
    show: {
      get() {
        return this.$store.getters['msg/show'];
      },

      set() {
        this.$store.commit('msg/showPopup', { });
      },
    },

    message() {
      return this.$store.getters['msg/message'];
    },

    title() {
      return this.$store.getters['msg/title'];
    },
  },
};
</script>
